export const visitStatusOptions = [
  { value: 'All', label: 'All' },
  { value: 'Fulfilled', label: 'Fulfilled' },
  { value: 'Cancelled', label: 'Cancelled' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Waitlisted', label: 'Waitlisted' }
]
